<template>
        <v-row>
           <v-col cols="7">
            <div class="elevation-3 pa-2 ml-3 mt-n4 grid-border">
            <v-row>
            <v-col cols="6">
                <label class="input-text-size pa-0">Clear Mortgage Codes :</label>
                <CommonDropDowns :isItTaxYearWithoutAllYears=true
                  @change="dataFromCommonDropDowns" />
                <CommonDropDowns :isItMtgCodeMutiSelect=true @change="dataFromCommonDropDowns"/>
            </v-col>
            <v-col cols="6" class="d-flex flex-column align-center justify-center">
               <v-badge v-if="!showLoader" :content="getCountRecords|| '0'" >
                </v-badge>
                <v-progress-circular v-if="showLoader"
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                <v-btn :class="`input-text-size`"
                text color="blue darken-1" class="mt-5" @click="handleResultCount">
                    Get Records Count
                </v-btn>
                <v-btn :class="`input-text-size`"
                text color="blue darken-1" class="mt-5"
                 :disabled="!clearMtgCodeStatus"
                 @click="clearMTGCode">
                    Clear Mtg Codes
                </v-btn>
            </v-col>
            </v-row>
          </div>
           </v-col>
            <v-col cols="5">
              <div class="elevation-3 pl-5 pa-2 mr-3 mt-n4">
              <v-row>
                <v-col cols="12">
                  <label class="input-text-size pa-0">
                    Update Mortgage Codes on Tax Roll Records :
                </label>
                <CommonDropDowns :isItMtgCode=true @change="dataFromCommonDropDowns"/>
                <v-radio-group v-model="radios" @change="handleOverRide">
                  <v-row>
                    <v-radio label='Add Mtg Code to All (override)'
                      class="input-text-size radio-and-checekbox-size"
                      value="overRideAll" />
                    <v-radio label='Add Mtg Code to Uncoded Only'
                      class="input-text-size radio-and-checekbox-size mt-n1"
                      value="uncodedOnly" />
                  </v-row>
                </v-radio-group>
                <v-btn :class="`input-text-size`"
                 text color="blue darken-1" @click="handleUpdateMTGCode">
                    Update Tax Records
                </v-btn>
                </v-col>
              </v-row>
            </div>
            </v-col>
        </v-row>
</template>

<script>
import {
  mapMutations, mapGetters, mapState, mapActions,
} from 'vuex';
import {
  mdiListStatus,
  mdiPlus,
} from '@mdi/js';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import '../../../assets/style.css';

export default {
  name: 'MtgCoBillRequestsFooter',
  components: {
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      radios: 'overRideAll',
      icons: {
        mdiListStatus,
        mdiPlus,
      },
      showLoader: false,
      statusDialog: false,
      clearMtgCodeStatus: false,
    };
  },
  created() {
  },
  destroyed() {
  },
  computed: {
    ...mapState({
      getCountRecords: (state) => state.tax.MortgageCoProcessing.getCountRecords,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
    }),
    ...mapGetters('base/crud', ['criteria']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setIsVisible',
      'setCriteria',
    ]),
    ...mapActions('tax/MortgageCoProcessing', [
      'getResultsCount', 'updateMTGCode', 'clearMortgageCodes',
    ]),
    ...mapActions(['flashSuccess', 'flashError', 'custumColrFlashMsg']),
    handleResultCount() {
      const criteria = { ...this.criteriaState };
      this.getResultsCount({ criteria });
      this.clearMtgCodeStatus = true;
    },
    async handleUpdateMTGCode() {
      const { baseCrudKey } = this;
      const upsert = { ...this.criteriaState };
      upsert.taxYear = this.latestTaxYear;
      if (upsert.mtgCode) {
        upsert.mtgStatus = this.radios;
        if (window.confirm('Are you sure want to update mortgage code?')) {
          const result = await this.updateMTGCode({ upsert, baseCrudKey });
          if (result.statusCode === 200) {
            this.$emit('loadCRUDList');
            this.flashSuccess('Mortgage code updated successfully');
          } else {
            this.flashError('There was a problem updating mortgage code');
          }
        }
      } else {
        alert('Please select Mortgage code');
      }
    },
    async clearMTGCode() {
      const { baseCrudKey } = this;
      if (!this.criteriaState.taxYear) {
        this.custumColrFlashMsg({ msg: 'Please select the correct tax year' });
        return;
      }

      const noCodeSelected = !(this.criteriaState.mtgCodeMulti || []).length;

      if (noCodeSelected) {
        const recordCount = this.getCountRecords || 0;
        const typed = window.prompt(
          `No mortgage code selected. This will clear the mortgage code from ALL ${recordCount} `
          + `records in tax year ${this.criteriaState.taxYear}. This cannot be undone.\n\n`
          + 'Type CLEAR ALL to confirm.',
        );
        if (typed !== 'CLEAR ALL') {
          return;
        }
      } else if (!window.confirm('Are you sure want to clear mortgage code?')) {
        return;
      }

      const upsert = { ...this.criteriaState };
      upsert.mtgCode = null;
      this.showLoader = true;
      const result = await this.clearMortgageCodes({
        upsert, confirmClearAll: noCodeSelected, baseCrudKey,
      });
      this.showLoader = false;
      if (result.statusCode === 200) {
        this.flashSuccess('Mortgage code cleared successfully');
        this.$emit('loadCRUDList');
        this.handleResultCount();
      } else {
        this.flashError('There was a problem clearing mortgage code');
      }
    },
    handleOverRide(value) {
      this.radios = value;
    },
    sharedMtgCodeFucToChangeValue(val) {
      this.criteriaState.mtgCode = val;
    },
    sharedMtgCodeFucToGetValue() {
      if (typeof (this.criteriaState.mtgCode) !== 'object') return [this.criteriaState.mtgCode];
      return this.criteriaState.mtgCode;
    },
    dataFromCommonDropDowns(val, whichField) {
      this.clearMtgCodeStatus = false;
      this.criteriaState[whichField] = val;
    },
  },
};
</script>

<style>
.rectangular-badge-content {
  border-radius: 4px;
  background-color: #1976d2; /* Match Vuetify's primary color or customize */
  color: white;
  padding: 0 8px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
